import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=6e7c652e&scoped=true"
import script from "./PublicFooter.vue?vue&type=script&lang=js"
export * from "./PublicFooter.vue?vue&type=script&lang=js"
import style0 from "./PublicFooter.vue?vue&type=style&index=0&id=6e7c652e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c652e",
  null
  
)

export default component.exports